export const init = () => {
    const $buttons = document.querySelectorAll(".c-Button:not(.-js-button-upgraded)")

    for (const $button of $buttons) {
        // If ripple button, wrap text value
        if ($button.classList.contains("-js-ripple")) {
            for (const $node of $button.childNodes) {
                if ($node.nodeType === 3) {
                    const $wrapper = document.createElement("div")
                    $wrapper.classList.add("c-Button__label")
                    $wrapper.textContent = $node.textContent.trim()
                    $button.insertBefore($wrapper, $node)
                    $button.removeChild($node)
                }
            }
        }

        $button.classList.add("-js-button-upgraded")
    }
}
